import { observer } from 'mobx-react-lite'
import React, {useState} from 'react'
import { useStore } from '../../../../../lib/context'
// import CategoryTag from '../../../General/CategoryTag'

const BBB = {
    "Business" : true,
    "Being" : true,
    "Beyond" : true,
}
const NavModuleSearchTag = observer(({children, active}) => {
    const {articleQueryStore: {activeTags, updateActiveTags, canAddTag}} = useStore();
    const isActive = !!activeTags[children];

    const isSeasonOne = children === "Season 1";
    const isSeasonTwo = children === "Season 2";
    const isBBB = !!BBB[children];

    return (
        <div 
            
            onClick={() => updateActiveTags(children)}
            className={`nav-module-search-tag ${isActive ? "active" : ""} ${isBBB ? "bbb" : ""} ${isSeasonOne ? "s-1" : ""} ${isSeasonTwo ? "s-2" : ""} ${!canAddTag ? "disabled" : ""}`}>
            {children}

            <style jsx>{`
                div {
                    display: inline-block;
                    padding: 10px 20px;
                    border-radius: 40px;
                    background: rgba(150,150,150,.75);
                    color: black;
                    white-space: nowrap;
                    font-size: 14px;
                    cursor: pointer;
                    transition: background .3s ease, color .3s ease, opacity .3s ease;
                }

                div:hover {
                    background: rgba(255,255,255,.75);
                }


                .s-2 {
                    color: white;
                    background: linear-gradient(to right, #e66465, #9198e5);
                }

                .s-1 {
                    color: white;
                    background: orange;
                }

                .bbb {
                    background: rgba(220,220,220, .75);
                    animation: changeBG 40s infinite;
                }

                @keyframes changeBG {
                    0% { background-color: #FFA4B7; }
                    14% { background-color: #90E15B; }
                    28% { background-color: #99E0D7; }
                    42% { background-color: #FC6463; }
                    57% { background-color: #E9C9B2; }
                    71% { background-color: #FFE01B; }
                    85% { background-color: #C380DF; }
                    100% { background-color: #FFA4B7; }
                }
                
                body {
                    animation: changeBG 10s infinite;
                }



                .active {
                    background: white;
                    opacity: .25;
                    color: black;
                    pointer-events: none;
                }

                .disabled {
                    pointer-events: none;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        font-size: 13px;
                    }
                }
            `}</style>
        </div>
    )
})

export default NavModuleSearchTag